<template>
    <div class="cart_result">
        <div class="row justify-content-center">
            <div class="col-10 col-sm-8 col-xl-4 cart_result_content">
                <h2 class="text-center">{{ title }}</h2>
                <h4 class="text-center">{{ content }}</h4>
                <template v-if="type == 'ATM'">
                    <div class="row justify-content-center">
                        <div class="col-5 col-sm-3 ml-auto">
                            <h3 class="justify">銀行</h3>
                        </div>
                        <div class="col-7 col-sm-7">
                            <p>{{ this.result.ATMBank }}</p>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-5 col-sm-3 ml-auto">
                            <h3 class="justify">銀行帳戶</h3>
                        </div>
                        <div class="col-7 col-sm-7">
                            <p>{{ this.result.ATMAccount }}</p>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-5 col-sm-3 ml-auto">
                            <h3 class="justify">匯款金額</h3>
                        </div>
                        <div class="col-7 col-sm-7">
                            <p>{{ this.result.PayPrice | currency }}</p>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-5 col-sm-3 ml-auto">
                            <h3 class="justify">匯款時間</h3>
                        </div>
                        <div class="col-7 col-sm-7">
                            <p>{{ this.result.ATMLimitDate }}</p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="text-center">
            <router-link :to="{ name: 'home' }" class="link hoverShallow">確認</router-link>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import orderApi from '@/api/order'

    export default {
        props: {
            type: {
                type: String,
                default() {
                    // return 'ATM';
                    // return 'Free';
                    return 'Credit';
                },
            },
            result: {
                type: Object,
                default() {
                    return {};
                },
            },
        },
        computed: {
            title() {
                if (this.type == 'Credit') {
                    if (this.result.ResponseCode != '00') {
                        return `【信用卡付款失敗通知】刷卡失敗,報名未成立。${this.result.ResponseCode}: ${decodeURI(this.result.ResponseMessage)}`;
                    }
                    return `【信用卡付款訂單通知】您已完成[特力集團]信用卡付款訂單，實際付款狀態請以[通知簡訊]為主或由[訂單/取消查詢]確認您的訂單。若訂單內的付款狀態為[未付款成功]，可能的原因為網路訊號不良或信用卡額度不足使得付款未成功。建議至網路訊號較佳場域，重新將您欲報名之課程加入購物車，再次付款完成報名作業。`;
                }

                if (this.type == 'Free') {
                    return `您已完成[特力集團]課程報名，課程詳情請見訂單管理查詢。`;
                }

                return 'ATM付款請於匯款時間截止前完成轉帳，未於時限內轉帳將自動取消報名資格，繳費成功後將以簡訊通知。';
            },
            content() {
                return '本公司絕不會以電話通知使用網路銀行、ATM、語音電話等進行付款變更或分期設定，請顧客切勿依電話指示操作。';
            },
        },
        created() {
            if (this.result.OrderNo) {
              orderApi.updateTspgOrder(this.result.OrderNo, this.result.ResponseCode, this.result.ResponseMessage,() => {
              });
            }
            if (_.isEmpty(this.result)) {
                this.$router.push({
                    name: 'home',
                });
            }
        },
    }
</script>
